/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app     = require('mag-app'),
    keys    = require('stb-keys'),
    actions = require('./handlers'),
    Modal   = require('mag-component-modal'),
    List    = require('mag-component-layout-list'),
    modalMenu = [
        {
            items: [
                {value: '', className: 'theme-icon theme-icon-rc-f1'},
                {value: gettext('Delete')}
            ],
            click: function () {
                actions.deleteContent();
                modal.hide(); //eslint-disable-line
            }
        }
    ],
    modal;

// if ( false ) {
//     modalMenu.push({
//         items: [
//             { value: '', className: 'theme-icon theme-icon-rc-f2'},
//             {value: _('Download')}
//         ],
//         click: function () {
//             actions.download();
//             modal.hide();
//         }
//     });
// }

modal = new Modal({
    title: gettext('Actions'),
    events: {
        show: function () {
            this.children[0].focus();
            app.footer.hide();
        },
        hide: function () {
            app.list.focus();
            if ( app.list.data.length ) {
                app.footer.show();
            }
        }
    },
    children: [
        new List({
            focusIndex: 0,
            size: modalMenu.length,
            data: modalMenu,
            events: {
                keydown: function ( event ) {
                    List.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back || event.code === keys.menu ) {
                        this.parent.hide();
                        app.list.focus();
                        event.stop = true;
                    }
                }
            }
        })
    ]
});


module.exports = modal;
